import { DOCUMENTS_PACKAGE_TYPE } from "../../data/static-data"

export const validateCalculatorData = (data, countryHasCity) => {
    const errors = {
        places: [],
    }
    let flag = true
    if (countryHasCity && !data["receiver-city"]) {
        flag = false
        errors["receiver-city"] = "calculator.errors.receiver_city.required"
    }
    if (!data["package-type"]) {
        flag = false
        errors["package-type"] = "calculator.errors.package_type.required"
    }

    if(!data.places) {
        flag = false
        errors.places = "calculator.errors.places.required"
        return {valid: flag, errors}
    }


    for(let i in data.places) {
        errors.places.push({
            "weight": "",
            "length": "",
            "width": "",
            "height": "",
        })

        if (!data.places[i].weight) {
            errors.places[i].weight = "calculator.errors.weight.required"
            flag = false
        }

        if(data["package-type"] === DOCUMENTS_PACKAGE_TYPE) {
            continue
        }
        if (!data.places[i].length) {
            errors.places[i].length = "calculator.errors.length.required"
            flag = false
        }
        if (!data.places[i].width) {
            errors.places[i].width = "calculator.errors.width.required"
            flag = false
        }
        if (!data.places[i].height) {
            errors.places[i].height = "calculator.errors.height.required"
            flag = false
        }
    }

    return {valid: flag, errors}
}